const paymentMethod = {
  pix: 'pix',
  ted: 'ted',
  boleto: 'boleto'
};

module.exports = paymentMethod;
